var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopulations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 24 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5H5V2H3V5H0V7H3V10H5V7H8V5ZM18 6C19.66 6 20.99 4.66 20.99 3C20.99 1.34 19.66 0 18 0C17.68 0 17.37 0.0499999 17.09 0.14C17.66 0.95 17.99 1.93 17.99 3C17.99 4.07 17.65 5.04 17.09 5.86C17.37 5.95 17.68 6 18 6ZM13 6C14.66 6 15.99 4.66 15.99 3C15.99 1.34 14.66 0 13 0C11.34 0 10 1.34 10 3C10 4.66 11.34 6 13 6ZM19.62 8.16C20.45 8.89 21 9.82 21 11V13H24V11C24 9.46 21.63 8.51 19.62 8.16ZM13 8C11 8 7 9 7 11V13H19V11C19 9 15 8 13 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulations);
export default __webpack_public_path__ + "static/media/populations.e6ad78ca9a8418a3a1f4fce592e08f20.svg";
export { ForwardRef as ReactComponent };